export const Role = {
	Admin: "Admin",
	Client: "Client",
	TC50: "Trans-colis 50",
	Agence: "Agence",
	EDI:"EDI"
};
